import { render, staticRenderFns } from "./SigningPersonRuleForm.vue?vue&type=template&id=5ca302e7&"
import script from "./SigningPersonRuleForm.vue?vue&type=script&lang=js&"
export * from "./SigningPersonRuleForm.vue?vue&type=script&lang=js&"
import style0 from "./SigningPersonRuleForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports